<ng-container *transloco="let t; prefix: 'entity-title'">
  {{renderText() | defaultValue}}
</ng-container>
